(function () {
  if (window.RealleaderManagedMedia) return;

  var mobileQuery = window.matchMedia('(max-width: 719px)');
  var managedVideos = [];

  function videoIsRendered(video) {
    return Boolean(video.getClientRects().length && window.getComputedStyle(video).visibility !== 'hidden');
  }

  function selectPoster(video) {
    var desktopPoster = video.getAttribute('data-rl-video-poster-desktop') || '';
    var mobilePoster = video.getAttribute('data-rl-video-poster-mobile') || desktopPoster;
    var nextPoster = mobileQuery.matches ? mobilePoster : desktopPoster;

    if (nextPoster && video.getAttribute('poster') !== nextPoster) {
      video.setAttribute('poster', nextPoster);
    }
  }

  function setupVideo(video) {
    if (video.dataset.rlManagedVideoReady === 'true') return;
    video.dataset.rlManagedVideoReady = 'true';
    var wantsAutoplay = video.dataset.rlVideoAutoplay === 'true' || video.autoplay;
    video.autoplay = wantsAutoplay;
    if (wantsAutoplay) {
      video.setAttribute('autoplay', '');
      video.preload = 'metadata';
    }
    selectPoster(video);

    var container = video.closest('[data-rl-video-container]') || video.parentElement;
    var toggle = container ? container.querySelector('[data-rl-video-toggle]') : null;
    var state = {
      video: video,
      toggle: toggle,
      inView: false,
      userPaused: false,
      userRequestedPlayback: false
    };

    function updateControl() {
      if (!toggle) return;
      var isPlaying = !video.paused && !video.ended;
      toggle.textContent = isPlaying ? 'Pause video' : 'Play video';
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }

    function playIfAllowed(fromUser) {
      if (!videoIsRendered(video)) return;
      if (!fromUser && state.userPaused) return;
      if (!fromUser && !state.inView) return;

      if (fromUser) {
        state.userRequestedPlayback = true;
        state.userPaused = false;
      }

      video.preload = 'metadata';
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(updateControl);
      }
    }

    function pauseVideo(userInitiated) {
      if (userInitiated) {
        state.userPaused = true;
        state.userRequestedPlayback = false;
      }
      video.pause();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused || video.ended) {
          playIfAllowed(true);
        } else {
          pauseVideo(true);
        }
      });
    }

    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    video.addEventListener('ended', updateControl);
    updateControl();

    if (wantsAutoplay) {
      var initialPlayPromise = video.play();
      if (initialPlayPromise && typeof initialPlayPromise.catch === 'function') {
        initialPlayPromise.catch(updateControl);
      }
    }

    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          state.inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          if (state.inView) {
            playIfAllowed(false);
          } else {
            pauseVideo(false);
          }
        });
      }, { threshold: [0, 0.2, 0.5] });
      state.observer.observe(video);
    } else {
      state.inView = true;
      playIfAllowed(false);
    }

    managedVideos.push(state);
  }

  function syncManagedVideos() {
    managedVideos = managedVideos.filter(function (state) {
      if (document.documentElement.contains(state.video)) return true;
      if (state.observer) state.observer.disconnect();
      return false;
    });

    managedVideos.forEach(function (state) {
      selectPoster(state.video);
      if (document.hidden || !videoIsRendered(state.video)) {
        state.video.pause();
      } else if (state.inView && !state.userPaused) {
        state.video.preload = 'metadata';
        var playPromise = state.video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('video[data-rl-managed-video], video.rl-reformer-hero-video').forEach(setupVideo);
    syncManagedVideos();
  }

  document.addEventListener('visibilitychange', syncManagedVideos);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    managedVideos = managedVideos.filter(function (state) {
      var belongsToSection = event.target === state.video || event.target.contains(state.video);
      if (!belongsToSection) return true;
      if (state.observer) state.observer.disconnect();
      state.video.pause();
      delete state.video.dataset.rlManagedVideoReady;
      return false;
    });
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncManagedVideos);
  } else {
    mobileQuery.addListener(syncManagedVideos);
  }

  init(document);
  window.RealleaderManagedMedia = { init: init, sync: syncManagedVideos };
})();
